<template>
  <div>
    <div class="d-flex flex-wrap mb-3" v-if="inventory.expertise.length">
      <v-chip
        v-for="(item, i) in inventory.expertise"
        :key="`picked-${i}`"
        class="ma-1"
        close
        @click:close="removeItem(item)"
      >
        {{ item }}
      </v-chip>
    </div>
    <v-row no-gutters>
      <v-col cols="11">
        <input
          type="text"
          @keyup.enter="addItem"
          v-model="name"
          placeholder="Type here"
          class="input_green"
        />
      </v-col>
      <v-col cols="1">
        <div class="d-flex justify-end">
          <v-btn
            min-width="10px"
            depressed
            width="36px"
            color="#016443"
            dark
            @click="addItem"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <p class="default_txt">
      Click plus or enter to add expertise and click save to save it
    </p>
    <div class="mt-5 d-flex justify-end">
      <v-btn depressed color="#016443" dark @click="updateData">
        <h5>Save</h5>
      </v-btn>
    </div>
    <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
      <v-progress-circular
        indeterminate
        class="mr-2"
        color="#006341"
      ></v-progress-circular>
      <b class="color_default">Loading...</b>
    </v-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["inventory"],
  name: "updateExpertiseTf",
  computed: {
    ...mapState({
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      find: "",
      name: "",
      loading: false,
    };
  },
  mounted() {},
  methods: {
    removeItem(i) {
      const index = this.inventory.expertise.indexOf(i);
      if (index > -1) {
        this.inventory.expertise.splice(index, 1);
      }
    },
    addItem() {
      if (this.name !== "") {
        this.inventory.expertise.push(this.name);
        this.name = "";
      }
    },
    updateData() {
      this.loading = true;
      let body = this.inventory;
      let role = this.role == "TF" ? "tf" : "vendor_user";
      let data = {
        path: `manage/${role}/update`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("success");
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.input_green {
  border: 2px solid var(--g);
  padding: 10px;
  border-radius: 5px;
  height: 38px;
  background: #fff;
  width: 100%;
}
.input_green:focus {
  outline: none;
}
.magnify {
  margin-right: -30px;
}
.bg-green {
  background-color: #006341;
  border-radius: 5px;
}
</style>
